import { BlogEntityTypeEnum } from '@/fo/api/magento';
import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { ArticleItem } from '@/fo/ui/article/list/base';
import { UiArticleTileBase } from '@/fo/ui/article/tile/base';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';

import { styles } from './UiArticleCarouselBase.styles';

export interface UiArticleCarouselBaseProps {
  articles: ArticleItem[];
  title: string;
  buttonText?: string;
  buttonLink?: string;
  className?: string;
  advertisingWarningText?: string;
}

export function UiArticleCarouselBase({
  articles,
  title,
  buttonText,
  buttonLink,
  className,
  advertisingWarningText
}: UiArticleCarouselBaseProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      <div className={slots.header()}>
        <h2 className={slots.title()}>{title}</h2>
        {buttonText && buttonLink && (
          <UiKitButtonBase
            className={slots.button()}
            as="link"
            color="ghost"
            href={buttonLink}
          >
            {buttonText}
            <ArrowIcon className={slots.icon()} />
          </UiKitButtonBase>
        )}
      </div>
      <UiKitCarouselBase
        className={slots.carousel()}
        viewportClassName={slots.viewport()}
        arrowPrevClass={slots.arrowPrev()}
        arrowNextClass={slots.arrowNext()}
        loop={false}
      >
        {articles.map((post) => (
          <UiArticleTileBase
            isVideo={post.type === BlogEntityTypeEnum.ExpertVideo}
            key={post.id}
            article={post}
            advertisingWarningText={advertisingWarningText}
          />
        ))}
      </UiKitCarouselBase>
    </div>
  );
}
